import $ from 'jquery';

export default class Dialog {
	constructor() {
		this.defaultOptions = {
			content: 'Are you sure?',
		};
		this.modal = null;
	}

	confirmClickHandler(callback) {
		this.modal.modal('hide');

		if (callback) {
			callback();
		}
	}

	cancelClickHandler(callback) {
		if (callback) {
			callback();
		}
	}

	show(options, onConfirm, onCancel) {
		options = $.extend(this.defaultOptions, options);

		this.modal = $('#simpleModal').clone();

		this.modal.appendTo('body');

		this.modal.modal();

		this.modal.find('.modal-header').remove();
		this.modal.find('.modal-body').html(options.content);

		this.modal.find('#simpleModalOk').on('click', () => {
			this.confirmClickHandler(onConfirm);
		});

		this.modal.find('#simpleModalCancel').on('click', () => {
			this.cancelClickHandler(onCancel);
		});

		this.modal.on('hidden.bs.modal', () => {
			this.modal.remove();
		});

		this.modal.modal('show');
	}
}
